import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var trainingDetailsRes;
export const trainingDetailsTodo = createAsyncThunk('trainingDetails', async (id) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'course/view_training_details',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "training_id": id,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return trainingDetailsRes = res.data
    } catch (error) {
        return trainingDetailsRes = error.response.data
    }
})


const trainingDetailsSlice = createSlice({
    name: 'trainingDetails',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(trainingDetailsTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('trainingDetails', state.data)
            }
        });
        builder.addCase(trainingDetailsTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default trainingDetailsSlice.reducer; 